import { Modal } from "antd";
import React from "react";
import Button from "../SignupProcess/Button/Button";
import "./InactiveModal.scss";
import HandGuy from "../../assets/hand-guy.svg";

export default function InactiveModal({ isOpen, onCancel }) {
  return (
    <Modal
      className="inactive-modal"
      onCancel={onCancel}
      open={isOpen}
      footer={null}
      wrapClassName="inactive-modal-wrap"
    >
      <div>
        <img src={HandGuy} />
        <h1>Are you still there?</h1>
        <p>Click below to continue.</p>
      </div>
      <Button
        label={"CONTINUE"}
        height={32}
        action={() => {
          window.location.reload();
        }}
      />
    </Modal>
  );
}
